import { inject, Injectable } from '@angular/core';
import { SearchParamsService } from '@educa/educa-ui';

@Injectable({ providedIn: 'any' })
export class FiltersService {
  private readonly searchParamsService = inject(SearchParamsService);
  filters = this.searchParamsService.getParam('filters');
  page = this.searchParamsService.getParam('page');
  private counterList = ['is_business_school', 'is_high_education', 'is_subscribed', 'has_teaching_tickets'];

  /**
   * Updates the filters applied to the search parameters.
   *
   * If the provided filter already exists in the current filters, it will be removed.
   * Otherwise, the filter will be added. If the filter belongs to the counterList,
   * all other filters from counterList will be removed before adding the new one since they are exclusive.
   *
   * @param filter - The filter key to add or remove from the current filters.
   */
  public setFilters(filter: string): void {
    const currentFilters = this.filters() || '';
    let filtersArray = currentFilters.split(',').filter((f) => f);

    if (filtersArray.includes(filter)) {
      filtersArray = filtersArray.filter((f) => f !== filter);
    } else {
      if (this.counterList.includes(filter)) {
        filtersArray = filtersArray.filter((f) => !this.counterList.includes(f));
      }
      filtersArray.push(filter);
    }

    const newFilter = filtersArray.join(',');
    this.searchParamsService.setParams({ filters: newFilter, page: null });
  }

  public isCounterEnabled(): boolean {
    for (const counter of this.counterList) {
      if (this.filters()?.includes(counter)) {
        return true;
      }
    }

    return false;
  }

  public setMasterclassFilters(filter: string): void {
    const currentFilters = this.filters() || '';
    const filtersArray = currentFilters.split(',').filter((f) => f);

    if (!filtersArray.includes(filter)) {
      filtersArray.pop();
      filtersArray.push(filter);

      const newFilter = filtersArray.join(',');
      this.searchParamsService.setParams({ filters: newFilter, page: null });
    }
  }
}
